import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Инициализация Telegram WebApp API
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (window.Telegram && window.Telegram.WebApp) {
      const webApp = window.Telegram.WebApp;
      
      // Определяем, является ли устройство мобильным
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Запрашиваем полноэкранный режим только для мобильных устройств
      if (isMobile && webApp.platform !== 'desktop') {
        webApp.requestFullscreen(); // Используем метод requestFullscreen вместо expand
      }
      
      // Отключаем вертикальные свайпы для Telegram
      webApp.disableVerticalSwipes();
      
      // Устанавливаем базовые CSS переменные для интерфейса
      // Фиксированные значения для мобильного представления
      document.documentElement.style.setProperty('--tg-viewport-height', `${webApp.viewportHeight}px`);
      document.documentElement.style.setProperty('--tg-viewport-stable-height', `${webApp.viewportStableHeight}px`);
      document.documentElement.style.setProperty('--safe-area-top', '0px');
      document.documentElement.style.setProperty('--telegram-top-safe-area', '80px');
      document.documentElement.style.setProperty('--telegram-bottom-safe-area', '80px');
      document.documentElement.style.setProperty('--telegram-nav-bottom-position', '30px');
      
      // Принудительно устанавливаем темную тему для body - цвета берутся из CSS
      document.body.classList.add('dark');
      document.body.classList.remove('light');
      
      console.log('Приложение инициализировано с темной темой и безопасными отступами');
      console.log('Telegram WebApp инициализирован успешно с поддержкой безопасных зон');
    } else {
      console.log('Telegram WebApp API не обнаружен или загружен некорректно');
    }
  } catch (error) {
    console.error('Ошибка при инициализации Telegram WebApp:', error);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
